import { useState } from "react";
import { Spinner } from "./Spinner";

export function LoadingButton({
  label,
  onClick,
  className = "",
  style,
  disabled = false,
  compact = false,
  type = "button",
  ...props
}) {
  const [isPending, setIsPending] = useState(false);

  const handleClick = async (e) => {
    if (isPending) return;

    if (onClick) {
      try {
        setIsPending(true);
        await onClick(e);
      } finally {
        setIsPending(false);
      }
    }
  };

  return (
    <button
      type={type}
      onClick={handleClick}
      disabled={disabled || isPending}
      className={`relative ${style}`}
      {...props}
    >
      {/* Absolute positioning wrapper for the spinner keeps layout shift at exactly zero */}
      {isPending && (
        <div className="absolute inset-0 flex items-center justify-center">
          <Spinner size={compact ? "md" : "lg"} className="text-white-900" />
        </div>
      )}
      <span className={isPending ? "opacity-0" : "opacity-100"}>{label}</span>
    </button>
  );
}
